import React from "react";
import {Link} from "react-router-dom";

export default function CategoryCell({category, link=null, linkReplace="CID", callback = null, ...props}) {

    const CategoryCellCard = function ({trainer, ...props}) { return <div className="card clickable mb-4 rounded-3 overflow-hidden hover-cell-effect"
                                                                          onClick={callback ? () => callback(category) : undefined}>
        {/*<ImageLoader src={category.cover} alt="" height={'180px'}/>*/}
        <img alt={''} src={category.cover} className="img-fit" style={
            {
                height: '180px',
                animation: "fadeIn 0.5s"
            }
        }/>
        <div className="card-body">
            <h6>{category.name}</h6>
        </div>
    </div>
    }

    return (<>
        {link && <Link className="text-decoration-none" to={link.replace(linkReplace, category.id)}><CategoryCellCard/></Link>}
        {!link && <CategoryCellCard />}
    </>);
}
